var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMute09(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mute-09_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F9AF17",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M822.5 335s157.5 157.5 0 354"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#35A4DD",
    d: "M691.6 6.3c-6.2 0-12.4 1.8-17.8 5.3L363.2 214.1H164c-17.9 0-32.5 14.6-32.5 32.5v514.7c0 17.9 14.5 32.5 32.5 32.5l179.9.2 329.7 218.3c5.4 3.6 11.7 5.4 17.9 5.4 5.3 0 10.6-1.3 15.4-3.9 10.5-5.7 17.1-16.7 17.1-28.6V345.3c.1-.8.1-1.6.1-2.4s0-1.6-.1-2.4c-1.2-16.9-15.3-30.2-32.5-30.2s-31.3 13.3-32.5 30.2c-.1.8-.1 1.6-.1 2.4 0 .8 0 1.6.1 2.4v579.4L371.6 734.4c-5.3-3.5-11.5-5.4-17.9-5.4l-157.2-.2V279.1h176.3c6.3 0 12.5-1.8 17.8-5.3l268.5-175v50.8c-.1.8-.1 1.6-.1 2.4s0 1.6.1 2.4c1.2 16.9 15.3 30.2 32.5 30.2s31.3-13.3 32.5-30.2c.1-.8.1-1.6.1-2.4 0-.8 0-1.6-.1-2.4V38.8c0-11.9-6.5-22.9-17-28.6-4.9-2.6-10.2-3.9-15.5-3.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#35A4DD",
    d: "M691.6 214.8c-17.2 0-31.3 13.3-32.5 30.2-.1.8-.1 1.6-.1 2.4s0 1.6.1 2.4c1.2 16.9 15.3 30.2 32.5 30.2s31.3-13.3 32.5-30.2c.1-.8.1-1.6.1-2.4s0-1.6-.1-2.4c-1.3-16.9-15.3-30.2-32.5-30.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute09);
export default ForwardRef;